module.exports = __webpack_public_path__ + "static/media/introduccion_a_la_persona.04daf300.md";